<template>
	<div v-if="dataLoaded">
		<v-toolbar color="blue lighten-1" class="white--text">
			<v-icon color="white">person</v-icon>
			<v-toolbar-title>Użytkownicy projektu</v-toolbar-title>
		</v-toolbar>
		<div class="ma-4">
			<v-layout row align-center>
				<v-flex xs1/>
				<v-flex xs3>
					<v-subheader><strong>Opiekun projektu</strong></v-subheader>
				</v-flex>
				<v-flex xs6>
					<div v-if="!users.supervisorName">-</div>
					<div v-else>
						<v-list two-line>
							<v-list-tile avatar class="list-item">
								<v-list-tile-avatar>
									<v-icon>person</v-icon>
								</v-list-tile-avatar>
								<v-list-tile-content>
									<v-list-tile-title v-html="users.supervisorName"
										style="font-size: 14px"></v-list-tile-title>
									<v-list-tile-sub-title
										v-html="users.supervisorEmail ? users.supervisorEmail : '-'"></v-list-tile-sub-title>
								</v-list-tile-content>
							</v-list-tile>
						</v-list>
					</div>
				</v-flex>
			</v-layout>
			<v-layout row align-center>
				<v-flex xs1/>
				<v-flex xs3>
					<v-subheader><strong>Oferent główny</strong></v-subheader>
				</v-flex>
				<v-flex xs6>
					<div v-if="!users.bidderName">-</div>
					<div v-else>
						<v-list two-line>
							<v-list-tile avatar class="list-item">
								<v-list-tile-avatar>
									<v-icon>person</v-icon>
								</v-list-tile-avatar>
								<v-list-tile-content>
									<v-list-tile-title v-html="users.bidderName"
										style="font-size: 14px"></v-list-tile-title>
									<v-list-tile-sub-title
										v-html="users.bidderLegalForm ? users.bidderLegalForm : '-'"></v-list-tile-sub-title>
									<v-list-tile-sub-title
										v-html="users.bidderEmail ? users.bidderEmail : '-'"></v-list-tile-sub-title>
								</v-list-tile-content>
							</v-list-tile>
						</v-list>
					</div>
				</v-flex>
			</v-layout>
		</div>
	</div>
</template>

<script>
	import {Project} from "../../../../api/generated/Project";

	export default {
		name: "ProjectSummaryUsersView",

		data () {
			return {
				users: {},
				dataLoaded: false
			};
		},

		created () {
			this.getProjectSummaryUsersData();
		},

		methods: {
			getProjectSummaryUsersData () {
				Project.getSummaryUsersData(this, this.$route.params.projectId, successResponse => {
						this.users = successResponse;
						this.dataLoaded = true;
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się załadować użytkowników projektu", errorResponse);
					});
			},
		}
	};
</script>

<style scoped>

</style>